<template>
<table class="table table-sm color">
    <caption class="caption table-caption">Deal Information</caption>
    <tbody>
    <tr>
        <th class="text-left font-weight-normal">Issue Date</th>
        <td class="text-right">{{issueDate}}</td>
    </tr>
    <tr>
        <th class="text-left font-weight-normal">Optional Cancellation Date</th>
        <td class="text-right">{{optionalCancellationDate}}</td>
    </tr>
    <tr>
        <th class="text-left font-weight-normal">Maturity Date</th>
        <td class="text-right">{{maturityDate}}</td>
    </tr>
    </tbody>
</table>
</template>

<script>
export default {
  props: [
    'issueDate',
    'optionalCancellationDate',
    'maturityDate'
  ]
}
</script>
